(function () {
  function getCookie(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\/+^])/g, '\\$1') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  function normalize(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function getDesiredTierLabel() {
    var tier = normalize(getCookie('vape_tier'));
    if (!tier) return null;
    return tier === 'federal' ? 'Federal' : 'Provincial';
  }

  function getMoneyFormat() {
    if (window.money_format) return window.money_format;
    if (window.Shopify && Shopify.money_format) return Shopify.money_format;
    return '${{amount}}';
  }

  function formatMoney(cents) {
    cents = parseInt(cents || 0, 10);
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, getMoneyFormat());
    }
    return cents;
  }

  function readChoiceLabel(node) {
    if (!node) return '';

    if (node.tagName === 'OPTION') {
      return (node.textContent || node.value || '').trim();
    }

    var dataValue = node.getAttribute('data-value');
    if (dataValue) return dataValue.trim();

    var dataTooltip = node.getAttribute('data-tooltip');
    if (dataTooltip) return dataTooltip.trim();

    var text = (node.textContent || '').trim();
    if (text) return text;

    var li = node.closest ? node.closest('li') : null;
    if (li) {
      var dataTag = li.getAttribute('data-tag');
      if (dataTag) return dataTag.trim();
    }

    return '';
  }

  function getLinks(group) {
    return Array.prototype.slice.call(group.querySelectorAll('a'));
  }

  function getSelect(group) {
    if (group.tagName === 'SELECT') return group;
    return group.querySelector('select');
  }

  function getValues(group) {
    var values = [];

    getLinks(group).forEach(function (link) {
      var label = readChoiceLabel(link);
      if (label && values.indexOf(label) === -1) values.push(label);
    });

    var select = getSelect(group);
    if (select) {
      Array.prototype.forEach.call(select.options, function (option) {
        var label = readChoiceLabel(option);
        if (label && values.indexOf(label) === -1) values.push(label);
      });
    }

    return values.map(normalize);
  }

  function isTaxZoneByValues(group) {
    var values = getValues(group);
    return values.indexOf('federal') > -1 && values.indexOf('provincial') > -1;
  }

  function getProductPageGroups(root) {
    return Array.prototype.slice.call(
      (root || document).querySelectorAll('.tt-product-single-info .tt-swatches-container-js .tt-wrapper')
    );
  }

  function getCardGroups(root) {
    return Array.prototype.slice.call(
      (root || document).querySelectorAll('.options-js .tt-option-block > ul.tt-options-swatch, .options-js .tt-option-block > .tt-select-box')
    );
  }

  function getSimplePriceBlocks(root) {
    return Array.prototype.slice.call(
      (root || document).querySelectorAll('[data-vape-price-scope="simple"]')
    );
  }

  function getProductPageGroupTitle(group) {
    var titleEl = group.querySelector('.tt-title-options');
    if (!titleEl) return '';

    var text = (titleEl.textContent || '').trim();
    if (text.indexOf(':') > -1) text = text.split(':')[0];
    return normalize(text);
  }

  function isProductPageTaxZoneGroup(group) {
    var title = getProductPageGroupTitle(group);
    if (title === 'tax zone' || title === 'pricing tier') return true;
    return isTaxZoneByValues(group);
  }

  function isCardTaxZoneGroup(group) {
    return isTaxZoneByValues(group);
  }

  function selectDesiredInLinks(group, desiredLabel) {
    var desired = normalize(desiredLabel);
    var links = getLinks(group);

    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var label = normalize(readChoiceLabel(link));
      if (label !== desired) continue;

      var li = link.closest ? link.closest('li') : null;
      var active = li && li.classList.contains('active');

      if (!active) link.click();
      return true;
    }

    return false;
  }

  function selectDesiredInSelect(group, desiredLabel) {
    var desired = normalize(desiredLabel);
    var select = getSelect(group);
    if (!select) return false;

    for (var i = 0; i < select.options.length; i++) {
      var option = select.options[i];
      var label = normalize(readChoiceLabel(option));
      if (label !== desired) continue;

      if (select.selectedIndex !== i) {
        select.selectedIndex = i;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return true;
    }

    return false;
  }

  function selectInGroup(group, desiredLabel) {
    if (group.dataset.vapeTierApplied === normalize(desiredLabel)) return true;

    var done = selectDesiredInLinks(group, desiredLabel) || selectDesiredInSelect(group, desiredLabel);
    if (done) group.dataset.vapeTierApplied = normalize(desiredLabel);
    return done;
  }

  function hideElement(el) {
    if (!el) return;
    el.classList.add('vape-tier-hidden');
    el.style.setProperty('display', 'none', 'important');
  }

  function productPageTierIsReady(root) {
    var desiredLabel = getDesiredTierLabel();
    if (!desiredLabel) return true;

    var desired = normalize(desiredLabel);
    var groups = getProductPageGroups(root);
    var matchedAny = false;
    var ready = true;

    groups.forEach(function (group) {
      if (!isProductPageTaxZoneGroup(group)) return;
      matchedAny = true;

      var activeLabel = '';
      var activeLink = group.querySelector('li.active a');
      if (activeLink) {
        activeLabel = normalize(readChoiceLabel(activeLink));
      } else {
        var select = getSelect(group);
        if (select && select.options.length) {
          activeLabel = normalize(readChoiceLabel(select.options[select.selectedIndex]));
        }
      }

      if (activeLabel !== desired) ready = false;
    });

    return matchedAny ? ready : true;
  }

  function revealProductPricesIfReady(root) {
    var prices = Array.prototype.slice.call(
      (root || document).querySelectorAll('.tt-product-single-info .tt-price')
    );

    if (!productPageTierIsReady(root)) {
      prices.forEach(function (el) {
        el.classList.remove('vape-tier-ready');
      });
      return;
    }

    prices.forEach(function (el) {
      el.classList.add('vape-tier-ready');
    });
  }

  function updateSimplePriceBlock(block, desiredLabel) {
    var desired = normalize(desiredLabel);
    if (block.dataset.vapePriceApplied === desired) return false;

    var scope = desired === 'federal' ? 'federal' : 'provincial';
    var price = block.getAttribute('data-' + scope + '-price') || block.getAttribute('data-default-price');
    var compare = block.getAttribute('data-' + scope + '-compare-price') || block.getAttribute('data-default-compare-price') || '';

    if (!price) return false;

    var main = block.querySelector('[data-role="main-price"]') || block.querySelector('span:first-child');
    var old = block.querySelector('[data-role="old-price"]') || block.querySelector('.old-price');

    if (main) main.innerHTML = formatMoney(price);

    compare = String(compare || '').trim();

    if (old) {
      if (!compare || parseInt(compare, 10) <= parseInt(price, 10)) {
        old.innerHTML = '';
        old.classList.add('hide');
        if (main) main.classList.remove('new-price');
      } else {
        old.innerHTML = formatMoney(compare);
        old.classList.remove('hide');
        if (main) main.classList.add('new-price');
      }
    }

    block.dataset.vapePriceApplied = desired;
    return true;
  }

  function applyProductPageTier(root) {
    var desiredLabel = getDesiredTierLabel();
    if (!desiredLabel) return;

    getProductPageGroups(root).forEach(function (group) {
      if (!isProductPageTaxZoneGroup(group)) return;
      selectInGroup(group, desiredLabel);
      hideElement(group);
    });
  }

  function applyCardTier(root) {
    var desiredLabel = getDesiredTierLabel();
    if (!desiredLabel) return;

    getCardGroups(root).forEach(function (group) {
      if (!isCardTaxZoneGroup(group)) return;
      selectInGroup(group, desiredLabel);
      hideElement(group);
    });
  }

  function applySimplePriceBlocks(root) {
    var desiredLabel = getDesiredTierLabel();
    if (!desiredLabel) return false;

    var changed = false;
    getSimplePriceBlocks(root).forEach(function (block) {
      if (updateSimplePriceBlock(block, desiredLabel)) changed = true;
    });
    return changed;
  }

  function injectStyle() {
    if (document.getElementById('vape-tier-hidden-style')) return;

    var style = document.createElement('style');
    style.id = 'vape-tier-hidden-style';
    style.textContent =
      '.vape-tier-hidden{display:none !important;}' +
      '.tt-product-single-info .tt-price{visibility:hidden;}' +
      '.tt-product-single-info .tt-price.vape-tier-ready{visibility:visible;}';
    document.head.appendChild(style);
  }

  function applyAll(root) {
    applyProductPageTier(root);
    applyCardTier(root);
    var changed = applySimplePriceBlocks(root);
    revealProductPricesIfReady(root);

    if (changed && window.jQuery) {
      jQuery('body').trigger('refreshCurrency');
    }
  }

  window.VapeProvinceSelector = {
    apply: applyAll
  };

  function init() {
    injectStyle();
    applyAll(document);
    requestAnimationFrame(function () {
      applyAll(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      applyAll(event.target || document);
    });

    if (window.jQuery) {
      jQuery(document).ajaxComplete(function (event, xhr, settings) {
        applyAll(document);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();